<template>
  <div>
    <Notification ref="notif" v-bind="notif" v-on:update="notif.show = $event"></Notification>
    <MessageDialog ref="objDialog" v-bind="objDialog" v-on:result="dialogClick"></MessageDialog>
    <v-toolbar color="green" flat dark fixed app>
      <v-toolbar-title>AGENT HEALTH</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
          <v-btn v-show="ShowAppRoute" flat @click="route('/controlboard')">Agents</v-btn>
          <v-btn v-show="ShowAppRoute" flat @click="route('/approverelease')">Approve Release</v-btn>
          <v-btn v-show="ShowAppRoute" flat @click="route('/Logs')">Logs</v-btn>
          <v-btn v-show="ShowAdminRoute" flat @click="route('/users')">Users</v-btn>
          <v-btn v-show="ShowAdminRoute" flat @click="route('/personas')">Personas</v-btn>
          <v-btn v-show="ShowAdminRoute" flat @click="route('/Audit')">Audit</v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn class="primary usernav" v-on="on">
                <v-icon left>account_circle</v-icon>
                {{FullName}}
                <v-icon style="margin-left:4px;">expand_more</v-icon>
              </v-btn>
            </template>
            <v-list dark class="primary usermenu">
              <v-list-tile v-show="ShowAdminOption">
                <v-list-tile-title @click="route(GetAdminOptionRoute)">Administrator</v-list-tile-title>
              </v-list-tile>
              <v-list-tile v-show="ShowAppOption">
                <v-list-tile-title @click="route(GetAppOptionRoute)">Application</v-list-tile-title>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-title @click="changePassword">Change Password</v-list-tile-title>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-title @click="Logout">Logout</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
      </v-toolbar-items>
    </v-toolbar>
    <v-dialog v-model="changePasswordWindow" max-width="500px">
          <v-card>
              <v-card-title>
                  <span class="headline">Change Password</span>
              </v-card-title>
              <v-card-text>
                  <v-form ref="changePasswordForm" v-model="validateChangePasswordForm" lazy-validation>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-text-field
                            label="Old Password"
                            type="password"
                            prepend-icon="edit"
                            v-model="objChangePassword.OldPassword"
                            :required="true"
                            :rules="[
                               v => !!v || 'Old Password is required'
                            ]"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                            label="New Password"
                            type="password"
                            prepend-icon="edit"
                            v-model="objChangePassword.Password"
                            :required="true"
                            :rules="[
                               v => !!v || 'New Password is required',
                               v => v !== objChangePassword.OldPassword || 'New and Old Password can not be same'
                            ]"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                            label="Re-Type Password"
                            type="password"
                            prepend-icon="edit"
                            v-model="objChangePassword.retypePassword"
                            :required="true"
                            :rules="[
                               v => !!v || 'Re-Type Password is required',
                               v => v === objChangePassword.Password || 'Password are not match'
                            ]"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                  </v-form>
              </v-card-text>
              <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-layout wrap>
                      <v-flex xs12>
                          <v-btn outline color="green darken-2" @click.native="done()">Done <v-icon right dark>check_circle</v-icon></v-btn>
                          <v-btn outline color="green darken-2" @click.native="changePasswordWindow = false">Cancel</v-btn>
                      </v-flex>
                      <v-flex xs12>
                          <v-progress-linear :indeterminate="true" height="5" color="green" v-if="actioninProgress"></v-progress-linear>
                      </v-flex>
                  </v-layout>
              </v-card-actions>
          </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DataService from '@/services/data-service';
import Notification from '@/components/Notification.vue';
import MessageDialog from '@/components/MessageDialog.vue';

const dataService = new DataService();

export default {
  name: 'mainToolbar',
  components: {
    Notification,
    MessageDialog,
  },
  props: {
    notif: {
      color: 'success',
      message: '',
      show: false,
    },
    objDialog: {
      dialog_title: '',
      dialog_body: '',
      btn_ok_text: 'Ok',
      btn_cancel_text: 'Cancel',
      show: false,
      result: undefined,
    },
  },
  data() {
    return {
      actioninProgress: false,
      changePasswordWindow: false,
      validateChangePasswordForm: false,
      objChangePassword: {
        UserId: this.$store.getters.getUserId,
        Username: this.$store.getters.getUsername,
        OldPassword: String,
        Password: String,
        retypePassword: String,
      },
    };
  },
  computed: {
    FullName() {
      return this.$store.getters.getUserFullName;
    },
    ShowAdminRoute() {
      return (this.$store.getters.getAdminRights && this.$route.meta && this.$route.meta.IsApp === false && this.$store.getters.IsValidCode(this.$route.meta.Code));
    },
    ShowAdminOption() {
      return (this.$store.getters.getAdminRights && this.$route.meta && this.$route.meta.IsApp === true);
    },
    GetAdminOptionRoute() {
      if (this.$store.getters.getAdminRights && this.$route.meta && this.$route.meta.IsApp === true) {
        const routeInfo = this.$store.getters.getDefaultAdminRoute;
        if (routeInfo.route) return `/${routeInfo.route}`;
      }
      return '/users';
    },
    ShowAppRoute() {
      return (this.$store.getters.getAppRights && this.$route.meta && this.$route.meta.IsApp === true && this.$store.getters.IsValidCode(this.$route.meta.Code));
    },
    ShowAppOption() {
      return (this.$store.getters.getAppRights && this.$route.meta && this.$route.meta.IsApp === false);
    },
    GetAppOptionRoute() {
      if (this.$store.getters.getAppRights && this.$route.meta && this.$route.meta.IsApp === false) {
        const routeInfo = this.$store.getters.getDefaultAppRoute;
        if (routeInfo.route) return `/${routeInfo.route}`;
      }
      return '/controlboard';
    },
  },
  methods: {
    dialogClick(res) {
      if (typeof this.objDialog.result === 'function') {
        this.objDialog.result(res);
      }
      this.objDialog.show = false;
    },
    showNotif(obj) {
      const that = this;
      that.notif.show = true;
      that.notif.message = obj.message;
      that.notif.color = obj.color;
    },
    route(path) {
      this.$router.replace(path);
    },
    changePassword() {
      this.objChangePassword.OldPassword = '';
      this.objChangePassword.Password = '';
      this.objChangePassword.retypePassword = '';
      this.$refs.changePasswordForm.resetValidation();
      this.changePasswordWindow = true;
    },
    done() {
      if (this.$refs.changePasswordForm.validate()) {
        this.actioninProgress = true;
        dataService.changePassword(this.objChangePassword)
          .then(((res) => {
            this.showNotif({ color: 'success', message: res });
            this.changePasswordWindow = false;
            this.actioninProgress = false;
          }))
          .catch((error) => {
            this.actioninProgress = false;
            this.showNotif({ color: 'error', message: error });
          });
      }
    },
    Logout() {
      this.actioninProgress = true;
      this.$store.dispatch('logout')
        .then((result) => {
          this.actioninProgress = false;
          if (result) this.$router.replace('/login');
          else this.showNotif({ color: 'error', message: 'Logout failed' });
        })
        .catch((error) => {
          this.actioninProgress = false;
          this.showNotif({ color: 'error', message: 'Logout failed' });
        });
    },
  },
};
</script>

<style>
.usernav {
  height: 49px !important;
  text-transform: none !important;
  box-shadow: none !important;
}
.v-toolbar__content {
  height: 50px !important;
}
.usermenu .v-list__tile {
  font-size: 14px !important;
  height: 28px !important;
  width: 150px !important;
  cursor: pointer;
}
</style>
